import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AddPriorities, UploadPriorities } from './priorities.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PrioritiesService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.prioritati.list;

    public listDTUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.prioritati.listDT;

    private findURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.prioritati.find;

    private storeURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.prioritati.store;

    private updateUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.prioritati.update;

    private deleteUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.prioritati.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.prioritati
            .listActive;

    private listPublicUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.prioritati
            .listPublic;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.prioritati
            .active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.prioritati
            .public;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: AddPriorities) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: UploadPriorities) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    getPrioritiesActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.listActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get priorities active:', error);
                    return throwError(error);
                })
            );
    }

    getPrioritiesPublic() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
